<template>
  <b-col class="">
    <b-row v-if="items.length">
      <b-col cols="12">
        <headerPdf title=" مجوزها " />
      </b-col>
    </b-row>
    <b-row>
      <b-col v-for="(item, i) in renderedItems" :key="i" cols="12">
        <div class="f-s-b-12 blockquote-footer my-2">
          <span class="f-s-b-12">
            {{ `${$lang.from_year} ${item.licenseYear}` }}
          </span>
          <span class="px-2 f-s-b-14">
            {{
              `${item.name} - ${item.licensePlaceName} - ${item.educationPlace} - ${item.address}`
            }}
          </span>
        </div>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import headerPdf from "../headerPdf.vue";
import { pathOr } from "ramda";

export default {
  name: "License",
  components: {
    headerPdf,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    renderedItems() {
      return this.items.map((item) => {
        return {
          licenseYear: pathOr("", ["license_year"], item),
          name: pathOr("", ["name"], item),
          licensePlaceName: pathOr("", ["license_place_name"], item),
          educationPlace: pathOr("", ["education_place"], item),
          address: pathOr("", ["location", "full_path"], item),
        };
      });
    },
  },
  methods: { pathOr },
};
</script>

<style lang="scss" scoped>
.information-pro {
  font-size: 14px;
  font-weight: 500;
  color: #282c52;
}
</style>
